exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".von-popover-arrow,.von-popover-arrow svg{position:absolute}.von-popover-arrow.bottom,.von-popover-arrow.top{width:100%;left:0}.von-popover-arrow.bottom svg,.von-popover-arrow.top svg{left:50%;top:0;margin-left:-4px}.von-popover-arrow.top{top:0}.von-popover-arrow.bottom{bottom:4px}.von-popover-arrow.left,.von-popover-arrow.right{height:100%;top:0}.von-popover-arrow.left svg,.von-popover-arrow.right svg{top:50%;left:0;margin-top:-4px}.von-popover-arrow.left{left:0}.von-popover-arrow.right{right:4px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js!./~/sass-loader!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/popover/arrow.vue
// module id = 169
// module chunks = 0